import { RouteObject } from "react-router"
import  TabMovimentacoes  from "./view/shell"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../data.types"
import { SupportAgent,Grading,Newspaper } from "@mui/icons-material"
import  {MovCadastroView} from "../movimentacoes/view/mov.cad"

export enum PathRotaTipoMov {
    tipoMov = "/movimentacoes",
    movCad = "/movimentacoes/cadastro"
}

const routerTipoMov: RouteObject = {
    path: PathRotaTipoMov.tipoMov,
    element: <TabMovimentacoes/>,
}

export const routerMovCadastro: RouteObject = {
    path: PathRotaTipoMov.movCad,
    element: <MovCadastroView/>,
}

export const navigationToTipoMovView = ()=> rotas.navigate(PathRotaTipoMov.tipoMov)
export const navigationToMovCadastroView = ()=> rotas.navigate(PathRotaTipoMov.movCad)

export function startRouterTipoMov(){
    const menu:MainMenu = {
        text:"Movimentações",
        icon:<Newspaper />,
        eventOnClick:navigationToTipoMovView
    }
    menuRotas.push(menu);
    return routerTipoMov
}